import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=9cf8ed28&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./../../../../../assets/mobileStyle.css?vue&type=style&index=0&id=9cf8ed28&prod&scoped=true&lang=css&"
import style1 from "./Index.vue?vue&type=style&index=1&id=9cf8ed28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf8ed28",
  null
  
)

export default component.exports